import { render, staticRenderFns } from "./Form-checkout.vue?vue&type=template&id=80d3f150&scoped=true&"
import script from "./Form-checkout.vue?vue&type=script&lang=js&"
export * from "./Form-checkout.vue?vue&type=script&lang=js&"
import style0 from "./scss/checkout.scss?vue&type=style&index=0&id=80d3f150&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d3f150",
  null
  
)

export default component.exports